import { ADD_BOOKING, DELETE_BOOKING } from "./actionTypes";

const initialState = {
  bookings: [],
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BOOKING:
      return {
        ...state,
        bookings: [
          ...state.bookings,
          {
            id: action.payload.id,
            from: action.payload.from,
            to: action.payload.to,
            date: action.payload.date,
            guests: action.payload.guests,
            ticketClass: action.payload.ticketClass,
          },
        ],
      };

    case DELETE_BOOKING:
      const restBookings = state.bookings.filter(
        (element) => element.id !== action.payload
      );

      return {
        ...state,
        bookings: restBookings,
      };

    default:
      return state;
  }
};

export default bookingReducer;
